import { Typography } from '@material-ui/core'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import LocalHotelIcon from '@material-ui/icons/LocalHotel'
import React from 'react'

import { getTranslate } from '../../../../localization'
import { DetailedRoomStays } from '../../../../types/cart'
import { Currency } from '../../../../types/currency'
import PerDayChargeRow from './PerDayChargeRow'
import PerRoomStayChargeRow from './PerRoomStayChargeRow'
import { useStyles } from './styles/index.styles'

type RoomStayPriceDetailsProps = {
  detailedRoomStays: DetailedRoomStays[]
  curruncy: Currency
}

const RoomStayPriceDetails: React.FC<RoomStayPriceDetailsProps> = ({
  detailedRoomStays,
  curruncy
}: RoomStayPriceDetailsProps) => {
  const classes = useStyles()
  return (
    <div className={classes.itemContainer}>
      {detailedRoomStays &&
        detailedRoomStays.map((d, i) => (
          <div key={i} className={classes.roomContainer}>
            <div className={classes.roomHeader}>
              <Typography variant="h5" className={classes.blackText}>
                {`${getTranslate('Room Stay')} ${i + 1}`}
              </Typography>
              <Typography variant="h6" className={classes.blackText}>
                {`${d.roomTypeName} ${d.displayRoomTypeCode} (${d.displayRatePlanCode})`}
              </Typography>
            </div>
            {d.chargePerDays.length > 0 && (
              <>
                <Typography variant="h5" className={classes.verticalAlign}>
                  <LocalHotelIcon className={classes.icon} />
                  {getTranslate('Per-Day Charge')}
                </Typography>
                <div className={classes.table} role="table">
                  <div className={classes.tableHeader} role="row">
                    <Typography
                      variant="h5"
                      className={classes.cell}
                      role="columnheader">
                      {getTranslate('Date')}
                    </Typography>
                    <Typography
                      variant="h5"
                      className={classes.cell}
                      role="columnheader">
                      {getTranslate('Item')}
                    </Typography>
                    <Typography
                      variant="h5"
                      className={classes.cell}
                      role="columnheader">
                      {getTranslate('Unit')}
                    </Typography>
                    <Typography
                      variant="h5"
                      className={classes.cell}
                      role="columnheader">
                      {getTranslate('Qty')}
                    </Typography>
                    <Typography
                      variant="h5"
                      className={classes.cell}
                      role="columnheader">
                      {getTranslate('Rate')}
                    </Typography>
                    <Typography
                      variant="h5"
                      className={classes.cell}
                      role="columnheader">
                      {getTranslate('Discount')}
                    </Typography>
                    <Typography
                      variant="h5"
                      className={classes.cell}
                      role="columnheader">
                      {getTranslate('Total')}
                    </Typography>
                    <Typography
                      variant="h5"
                      className={classes.cell}
                      role="columnheader">
                      {getTranslate('Remarks')}
                    </Typography>
                  </div>
                  {d.chargePerDays.map((chp, index) => (
                    <PerDayChargeRow
                      chargePerDay={chp}
                      key={index}
                      curruncy={curruncy}
                    />
                  ))}
                  <PerDayChargeRow
                    isTotal
                    total={d.totalChargePerDay}
                    curruncy={curruncy}
                  />
                </div>
              </>
            )}
            {d.chargePerRoomStay.length > 0 && (
              <>
                <Typography variant="h5" className={classes.verticalAlign}>
                  <AddCircleIcon className={classes.icon} />
                  {getTranslate('Per-RoomStay Charge')}
                </Typography>
                <div className={classes.table} role="table">
                  <div className={classes.tableHeaderForRoomStay}>
                    <Typography
                      variant="h5"
                      className={classes.cell}
                      role="columnheader">
                      {getTranslate('Item')}
                    </Typography>
                    <Typography
                      variant="h5"
                      className={classes.cell}
                      role="columnheader">
                      {getTranslate('Unit')}
                    </Typography>
                    <Typography
                      variant="h5"
                      className={classes.cell}
                      role="columnheader">
                      {getTranslate('Qty')}
                    </Typography>
                    <Typography
                      variant="h5"
                      className={classes.cell}
                      role="columnheader">
                      {getTranslate('Rate')}
                    </Typography>
                    <Typography
                      variant="h5"
                      className={classes.cell}
                      role="columnheader">
                      {getTranslate('Discount')}
                    </Typography>
                    <Typography
                      variant="h5"
                      className={classes.cell}
                      role="columnheader">
                      {getTranslate('Total')}
                    </Typography>
                    <Typography
                      variant="h5"
                      className={classes.cell}
                      role="columnheader">
                      {getTranslate('Remarks')}
                    </Typography>
                  </div>
                  {d.chargePerRoomStay.map((chps, idx) => (
                    <PerRoomStayChargeRow
                      key={idx}
                      chargePerRoomStay={chps}
                      curruncy={curruncy}
                    />
                  ))}
                  <PerRoomStayChargeRow
                    isTotal
                    total={d.totalChargePerRoomStay}
                    curruncy={curruncy}
                  />
                </div>
              </>
            )}

            {/* No standalone promotion line: the per-day rows carry the deduction inline
                (Rate 6,000,000, Discount 600,000, Total 5,400,000). A separate line here would
                subtract it a second time -- it existed only while the day rows were gross. */}

            {/* <DiscountDetails /> */}
            {/* <Divider /> */}
          </div>
        ))}
    </div>
  )
}

export default RoomStayPriceDetails
